<template>
  <div class="el-date-editor el-input el-input--prefix el-input--suffix el-date-editor--month" ref="quarterDiv">
    <div class="mask-wrapper"
         v-show="showSeason"
         @click.stop="showSeason = false"></div>
    <el-popover placement="bottom" popper-class="quarter-popover-custom" trigger="manual" v-model="showSeason" :append-to-body="false">
      <div ref="quarterPopoverCustom" class="season-picker-box">
        <div class="el-date-picker__header el-date-picker__header--bordered">
          <i aria-label="前一年"
             class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
             @click="prev" />
          <span role="button" class="el-date-picker__header-label">{{ year }}年</span>
          <i aria-label="后一年"
             @click="next"
             class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right" />
        </div>

        <div class="el-picker-panel__content">
          <table class="el-month-table">
            <tr>
              <td :class="isOneDisabled?'':'disabled'">
                <div>
                  <template v-if="isOneDisabled">
                    <el-button class="cell" @click="selectSeason(1)" type="text">一季度</el-button>
                  </template>
                  <template v-else>
                    <el-button class="cell" style="color: #606266;" type="text" disabled>一季度</el-button>
                  </template>
                </div>
              </td>
              <td :class="isTwoDisabled?'':'disabled'">
                <div>
                  <template v-if="isTwoDisabled">
                    <el-button class="cell" @click="selectSeason(2)" type="text">二季度</el-button>
                  </template>
                  <template v-else>
                    <el-button class="cell" style="color: #606266;" type="text" disabled>二季度</el-button>
                  </template>
                </div>
              </td>
            </tr>
            <tr>
              <td :class="isThreeDisabled?'':'disabled'">
                <div>
                  <template v-if="isThreeDisabled">
                    <el-button class="cell" @click="selectSeason(3)" type="text">三季度</el-button>
                  </template>
                  <template v-else>
                    <el-button class="cell" style="color: #606266;" type="text" disabled>三季度</el-button>
                  </template>
                </div>
              </td>
              <td :class="isFourDisabled?'':'disabled'">
                <div>
                  <template v-if="isFourDisabled">
                    <el-button class="cell" @click="selectSeason(4)" type="text">四季度</el-button>
                  </template>
                  <template v-else>
                    <el-button class="cell" style="color: #606266;" type="text" disabled>四季度</el-button>
                  </template>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <el-input slot="reference"
                placeholder="请选择季度"
                v-model="strValue"
                ref="quarterInput"
                prefix-icon="el-icon-date"
                @focus="hFcus" />
    </el-popover>
  </div>
</template>
<script>
export default {
  name: 'zycQuarter',
  model: {
    prop: 'quarterValue',
    event: 'quarterChange'
  },
  props: {
    quarterValue: '',
    qChange: {
      type: Function,
      default: () => { }
    },
    maxYear: {
      type: Number,
      default: new Date().getFullYear()
    },
    minYear: {
      type: Number,
      default: new Date().getFullYear()
    },
    maxQuarter: {
      type: String,
      default: ''
    },
    minQuarter: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showSeason: false,
      year: new Date().getFullYear(),
      strValue: '',
      current: '',
      isOneDisabled: true,
      isTwoDisabled: true,
      isThreeDisabled: true,
      isFourDisabled: true
    };
  },
  watch: {
    showSeason(val) {
      if (val) {
        this.current = this.quarterValue
      }
    },
    quarterValue(val) {
      if (val == '') {
        this.strValue = val
      }
    },
    maxYear(val) {
      this.year = this.year > val ? val : this.year
    },
    minYear(val) {

    }
  },
  mounted() {
    this.checkDisabled()
  },
  created() {
  },
  methods: {
    prev() {
      this.year = this.year * 1 - 1;
      if (this.year <= this.minYear) {
        this.year = this.minYear
      }
      this.checkDisabled()
    },
    next() {
      this.year = this.year * 1 + 1;
      if (this.year >= this.maxYear) {
        this.year = this.maxYear
      }
      this.checkDisabled()
    },
    selectSeason(i) {
      this.season = `${this.year}-${i}`;
      this.qChange(this.season)
      this.showSeason = false;
      const cnNum = ['一', '二', '三', '四']
      this.strValue = `${this.year}年${cnNum[i - 1]}季度`;
    },
    hFcus: function () {
      this.showSeason = true
      this.checkDisabled()
      this.$refs.quarterInput.blur()
      document.addEventListener('click', event => {
        const e = event || window.event
        if (this.$refs.quarterDiv && !this.$refs.quarterDiv.contains(e.target)) {
          this.showSeason = false
        }
      })
    },
    setValue: function (val) {
      if (val == '') {
        this.strValue = ''
      } else {
        const cnNum = ['一', '二', '三', '四']
        this.strValue = val.split('-')[0] + '年' + cnNum[Number(val.split('-')[1]) - 1] + '季度'
      }
    },
    cancel: function () {
      this.year = new Date().getFullYear()
    },
    checkDisabled: function () {
      if (this.maxQuarter && this.minQuarter) {
        var maxY = Number(this.maxQuarter.split('-')[0])
        var maxQ = Number(this.maxQuarter.split('-')[1])
        var minY = Number(this.minQuarter.split('-')[0])
        var minQ = Number(this.minQuarter.split('-')[1])
        if (this.year >= minY && this.year <= maxY) {
          this.isOneDisabled = true
          this.isTwoDisabled = true
          this.isThreeDisabled = true
          this.isFourDisabled = true
          if (this.year == maxY) {
            for (var i = 1; i <= 4; i++) {
              if (i > maxQ) {
                switch (i) {
                  case 1:
                    this.isOneDisabled = false
                    break
                  case 2:
                    this.isTwoDisabled = false
                    break
                  case 3:
                    this.isThreeDisabled = false
                    break
                  case 4:
                    this.isFourDisabled = false
                    break
                }
              }
            }
          }
          if (this.year == minY) {
            for (var i = 1; i <= 4; i++) {
              if (i < minQ) {
                switch (i) {
                  case 1:
                    this.isOneDisabled = false
                    break
                  case 2:
                    this.isTwoDisabled = false
                    break
                  case 3:
                    this.isThreeDisabled = false
                    break
                  case 4:
                    this.isFourDisabled = false
                    break
                }
              }
            }
          }
        } else {
          this.isOneDisabled = false
          this.isTwoDisabled = false
          this.isThreeDisabled = false
          this.isFourDisabled = false
        }
      }
    }
  },
};
</script>
<style lang="scss">
  .quarter-popover-custom {
    padding: 0;
    width: 345px !important;

    .el-month-table {
      width: 100%;
    }

  }
</style>

<style lang="scss" scoped>
.mask-wrapper {
  z-index: 999;
  width:100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/zyc/other/quarter.vue